<div
  class="wrapper"
  [class.interaction-disabled]="serviceTicketStore.callTypeInteractionDisabled$ | async"
  *ngrxLet="{
    isSalesforceWithGermanyCompany: serviceTicketStore.isSalesforceWithGermanyCompany$ | async,
    canRequestCallNow: serviceTicketStore.canRequestCallNow$ | async,
    isRoutingProviderError: serviceTicketStore.isRoutingProviderError$ | async
  } as serviceTicket"
>
  <mat-radio-group name="transfer-option" class="flex flex-col">
    <ng-container
      *ngIf="
        serviceTicket.isSalesforceWithGermanyCompany ||
        (isAllowedToUseCallNowByVkorg && !routingProvider && !serviceTicket.isRoutingProviderError)
      "
    >
      <mat-radio-button
        [disabled]="!isCallNowAvailable"
        gtm="onSelect"
        gtmAction="Call now"
        gtmCategory="ServiceTicket"
        class="radio-btn"
        [class.disabled]="!isCallNowAvailable"
        [value]="ServiceTicketCallType.CallNow"
        [checked]="selectedCallType === ServiceTicketCallType.CallNow"
        (click)="onToggle(ServiceTicketCallType.CallNow)"
        ><span class="radio-text">{{
          '+SERVICE_TICKET.CALL_NOW_OPTION_NAME' | translate
        }}</span></mat-radio-button
      >
      <div class="option-content" *ngIf="selectedCallType === ServiceTicketCallType.CallNow">
        <div class="option-title">{{ '+SERVICE_TICKET.CALL_NOW_OPTION_TITLE' | translate }}</div>
        <div>
          {{ '+SERVICE_TICKET.CALL_NOW_OPTION_DESCRIPTION' | translate }}
        </div>
      </div>
    </ng-container>

    <mat-radio-button
      gtm="onSelect"
      gtmAction="Arrange a callback"
      gtmCategory="ServiceTicket"
      class="radio-btn"
      [value]="ServiceTicketCallType.ArrangedCallback"
      [checked]="selectedCallType === ServiceTicketCallType.ArrangedCallback"
      (click)="onToggle(ServiceTicketCallType.ArrangedCallback)"
      ><span class="radio-text">{{
        '+SERVICE_TICKET.ARRANGE_CALLBACK_OPTION_NAME' | translate
      }}</span></mat-radio-button
    >
    <div class="option-content" *ngIf="selectedCallType === ServiceTicketCallType.ArrangedCallback">
      <div class="option-title">{{ '+SERVICE_TICKET.CONTACT_METHOD_TITLE' | translate }}</div>
      <div class="option-spacing">
        {{ '+SERVICE_TICKET.MATERIAL_DELIVERY_DESCRIPTION' | translate }}
      </div>

      <div class="phone-number-wrapper">
        <div class="flag-box">
          <mat-form-field mat-select-height-large>
            <mat-select
              [(ngModel)]="langCode"
              (selectionChange)="onLangCodeChange($event)"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span class="flag {{ getCountryFlag(langCode) }}"></span>
                {{ getDialCodeValue(langCode) }}
              </mat-select-trigger>
              <mat-option
                *ngFor="let key of keys"
                value="{{ key }}"
                gtm="onSelect"
                gtmAction="Language"
                gtmCategory="settings"
                fieldTextContentTooltip
              >
                <span class="flag {{ getCountryFlag(key) }}"></span>

                {{ dialCodeValues[key] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field mat-input-height-large-label class="flex-1">
          <mat-label>{{ '+SERVICE_APP.EDIT_PHONE_NUMBER.PLACEHOLDER' | translate }}</mat-label>
          <input
            data-at-phone-input
            matInput
            maxLength="15"
            [formControl]="phoneNumberWithoutDialCodeFormControl"
            name="phoneNumberWithoutDialCode"
            gtm="onEditTextField"
            gtmAction="Phone number"
            gtmCategory="Service Ticket"
            [gtmOn]="['change', 'focus', 'blur']"
          />
          <mat-error *ngIf="phoneNumberWithoutDialCodeFormControl.hasError('phoneEmpty')">{{
            '+VALIDATORS.PHONE_NUMBER_NO_VALUE' | translate
          }}</mat-error>
          <mat-error
            *ngIf="phoneNumberWithoutDialCodeFormControl.hasError('phoneInvalidCharacters')"
            >{{ '+VALIDATORS.PHONE_NUMBER_INVALID_CHARACTERS' | translate }}</mat-error
          >
          <mat-error *ngIf="phoneNumberWithoutDialCodeFormControl.hasError('phoneInvalid')">{{
            '+VALIDATORS.PHONE_NUMBER_INVALID' | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-radio-group>

  <ng-container
    *ngIf="
      (serviceTicket.isSalesforceWithGermanyCompany && serviceTicket.canRequestCallNow) ||
      (isAllowedToUseCallNowByVkorg &&
        !routingProvider &&
        serviceTicket.canRequestCallNow &&
        !serviceTicket.isRoutingProviderError)
    "
  >
    <button
      *ngIf="selectedCallType === ServiceTicketCallType.CallNow"
      data-at-call-now-btn
      mat-raised-button
      gtm="onSelect"
      gtmAction="Call now button"
      gtmCategory="ServiceTicket"
      color="primary"
      mat-button
      (click)="onCallNowClicked()"
    >
      <span>{{ '+SERVICE_TICKET.CALL_NOW_BUTTON' | translate }}</span>
    </button>
  </ng-container>

  <button
    *ngIf="selectedCallType === ServiceTicketCallType.ArrangedCallback"
    data-at-arrange-callback-btn
    mat-raised-button
    gtm="onSelect"
    gtmAction="Arrange callback button"
    gtmCategory="ServiceTicket"
    color="primary"
    mat-button
    [disabled]="!(serviceTicketStore.canRequestArrangedCallback$ | async)"
    (click)="onArrangeCallbackClicked()"
  >
    <span>{{ '+SERVICE_TICKET.ARRANGE_CALL_BUTTON' | translate }}</span>
  </button>
</div>
